export default {
  user: {
    id: null,
    name: ""
  },
  globalTimePeriod: null
};
